import React, { useEffect, useMemo, useState } from "react";
import { useTable, useSortBy } from "react-table";

import { OverlayTrigger, Tooltip } from "react-bootstrap";
import PaginationAndSearching from "../../../components/Pagination Component/paginationAndSearching";
import SkeletonTableRow from "../../../components/SkeltonTable/skeletonTable";
import { useDispatch, useSelector } from "react-redux";
import { getUserByPropIdApi } from "../../../../service/property/getUserByPropId";
import { removePropertyVendorApi } from "../../../../service/property/removePropertyVendor";
import { setLoading } from "../../../../feature/authSlice";
import { findSubMenuByName } from "../../propertyList/MenuUtlis";

export const AssignedVendorTable = ({
  column,
  rowsArr,
  handleVerify,
  handleSearchPagination,
  searchValuePagination,
  pageSizePagination,
  handleChangeRowsPerPagePagination,
  totalCountPagination,
  handleOnChangePagination,
  showLoading,
  handleDeleteById,
  handleTabExpanded,
  userArr,
  handleActionMultipleApprove,
  handleSeeVendor,
  handleEditVendor,
  handleLoadData,
  tab
}) => {
  const {permissionArr} = useSelector(state =>state.auth)
  const { permissions } = useSelector((state) => state.permissionsData);
  const dispatch = useDispatch()
  const columns = useMemo(() => column, []);
  const data = useMemo(() => rowsArr, [rowsArr]);
  const userData = useMemo(() => userArr, [userArr]);
  const [checkedRows, setCheckedRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const tableInstance = useTable({ columns, data }, useSortBy);
useEffect(()=>{},[userArr])
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    //footerGroups,
    rows,
    prepareRow,
  } = tableInstance;
  const [expandedRowIndex, setExpandedRowIndex] = useState(null);

const [buttonLoadingApi,setButtonLoadingApi] = useState(false)
 
  const toggleRowExpansion = (index) => {
    setExpandedRowIndex((prevIndex) => (prevIndex === index ? null : index));
  };
const [userArray,setUserArray] = useState([])
  function handleUserData(val)  {
setUserArray([])
    var data  ={
      PropertyId:val.Id
    }
    dispatch( (data,(res)=>{
      console.log(res.data?.result)
      setUserArray(res.data?.result)
    },()=>{}))
  }


  function removeAssignedVendor(){
    setButtonLoadingApi(true)
    const transformedRows = checkedRows.map(row => ({
      PropertyId:localStorage.getItem("propId"),
      VendorId:row.Id
    }
    
  
    ));
   
    dispatch(removePropertyVendorApi(transformedRows,()=>{
      setButtonLoadingApi(false)
     
      setCheckedRows([])
      handleLoadData()
    },()=>{
      setButtonLoadingApi(false)
     
    }))

  }
  
  const handleCheckboxChange = (row) => {
    setCheckedRows((prevCheckedRows) => {
      console.log(prevCheckedRows,"hh")
      const isChecked = prevCheckedRows.some(checkedRow => checkedRow.Id === row.Id);
      const updatedCheckedRows = isChecked
        ? prevCheckedRows.filter(checkedRow => checkedRow.Id !== row.Id)
        : [...prevCheckedRows, row];

      onSelectedRowsChange(updatedCheckedRows); // Pass the updated selected rows to parent
      return updatedCheckedRows;
    });
  };

  function onSelectedRowsChange(e){
    setCheckedRows(e)

  }


    // Helper function to check if a specific action exists in a submenu
    const hasAction = (submenu, actionName) => submenu?.Actions.includes(actionName);

    // Find the "Properties" menu
    const propertiesMenu = findSubMenuByName(permissions, 'Properties');
    const listPropertyMenu = propertiesMenu ? findSubMenuByName(propertiesMenu?.SubMenus, 'Add Property') : null;
    const canNewRemove = listPropertyMenu ? hasAction(listPropertyMenu, 'Remove') : false;
  return (
    <>

   
        <div className="card-header">
     
        <div className="d-flex justify-content-between" style={{width:'100%'}}>
        {  checkedRows.length >0 &&<div>
  <button type="submit" disabled={canNewRemove?false:true} className="btn btn-primary" onClick={removeAssignedVendor}>
                  Remove Vendor
                </button>
          </div>}
            {/* <div className="service-input-group input-group" style={{width:"220px"}}>
                        <span className="input-group-text search-input-icon">

                            <i className="bi bi-search" style={{ fontSize: '16px' }}></i>
                        </span>
                        <input
                            type="text"
                            className="form-control search-input"
                            id="val-username1"
                            placeholder="Search..."
                            name="username"
                            value={searchValuePagination}
                            onChange={handleSearchPagination}
                        />
                    </div> */}
            </div>
        </div>
    
          <div className="table-responsive">
            <div className="dataTables_wrapper">
              <table {...getTableProps()} className="table dataTable display" style={{zoom:'0.9'}}>
             {!showLoading && <>
              <thead>
                  {headerGroups.map((headerGroup) => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column) => (
                        <th
                          {...column.getHeaderProps(
                            column.getSortByToggleProps()
                          )}
                          style={{ color: "rgba(23, 90, 169, 0.78)" }}
                        >
                          {column.render("Header")}
                          <span className="ml-1">
                            {column.isSorted ? (
                              column.isSortedDesc ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
             
                <tbody {...getTableBodyProps()}>
                  {rows.map((row, rowIndex) => {
                    prepareRow(row);
                    return (

                      <>
                       <tr {...row.getRowProps()}>
                        {row.cells.map((cell, cellIndex) => {
                      const firstCol = cellIndex === 0;
                      const SecondCol = cellIndex === 1;
                    
                    
                      // {console.log(cell.render("Cell") )}

                          return (

                            
                          
                            
                            <td
                              {...cell.getCellProps()}
                              style={{ color: "black" ,whiteSpace:'normal' }}
                            >

                              {
                                firstCol ? (
                                
                                <div>
                                   <input
                                      type="checkbox"
                                      checked={checkedRows.some(checkedRow => checkedRow.Id === row.original.Id)}
                                      onChange={() => handleCheckboxChange(row.original)}
                                    />
                                </div>
                              
                              ):(
                                <div>
                                {
                                                                      (cell.column.id === "VendorName" && (
                                                                       <>
                                                                       <div style={{ marginLeft: '15px', maxWidth: '150px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} 
 title={rows[rowIndex].original.VendorName}>
{SecondCol && rows[rowIndex].original.VendorName}
</div></> 
                                                                      ))||
                                (cell.column.id === "VendorEmail" && (
<div>
{cell.value.split(/[,/]/).map((email, index) => (
  <div key={index}>{email}</div>
))}
</div>
)) ||                                    (cell.column.id === "VendorPhone" && (
<div>
{cell.value.split(/[,/]/).map((email, index) => (
  <div key={index}>{email}</div>
))}
</div>
)) || cell.render("Cell")  }
</div>
                                )
                              }
                         
                         
                       
                           
                            </td>
                          );
                        })}

                      </tr>
                    
                      </>
                     

                      
                      
                    );
                  })}
                </tbody></>}
             {showLoading &&   <SkeletonTableRow cols={4} row ={4}/>}
                {/* This is only for footer if u require */}
              </table>

              {rows.length === 0 && (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  No record found
                </div>
              )}

            </div>
{/*      
          
<PaginationAndSearching
                  handleSearch={handleSearchPagination}
                  searchValue={searchValuePagination}
                  defaultValue={pageSizePagination}
                  handleChangeRowsPerPage={handleChangeRowsPerPagePagination}
                  totalCount={totalCountPagination}
                  onChange={(e,p)=>{
                    handleOnChangePagination(e,p)
                    // setCheckedRows([])
                  }}
                /> */}
             
        </div>
    
    </>
  );
};
export default AssignedVendorTable;
